import { render, staticRenderFns } from "./RejectReferral.vue?vue&type=template&id=a7fb3566&scoped=true"
import script from "./RejectReferral.vue?vue&type=script&lang=js"
export * from "./RejectReferral.vue?vue&type=script&lang=js"
import style0 from "./RejectReferral.vue?vue&type=style&index=0&id=a7fb3566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fb3566",
  null
  
)

export default component.exports